import withReducer from '../../store/withReducer'
import TeamMemberFile from './container'
import reducer from './module'

export default withReducer('teamMemberFile', reducer)(TeamMemberFile)



// WEBPACK FOOTER //
// ./src/legacy/pages/TeamMemberFile/index.js